import {DotPhraseBase} from '@ng-dot/text';

/**
 * 내장 구문 기반
 *
 * 지원 언어가 단일 일 때만 사용 합니다.
 * 다중 언어일 때에는 `LazyPhraseService`를 사용 해야 합니다.
 */
export abstract class PhraseBase extends DotPhraseBase<string> {
	/**
	 * 구문 설정
	 */
	abstract readonly values: Record<string, string>;

	get phrases(): Record<string, string> {
		return {
			[this._translate.language]: this.values
		} as any;
	}

	/**
	 * 단일 구문을 얻습니다.
	 * @param token
	 * @param values
	 */

	get<T extends keyof this['values']>(token: T, values?: any) {
		return super.get(token as any, values);
	}

	/**
	 * 다중 구문의 이름을 변경하여 얻습니다.
	 * @param map
	 */
	gets<T extends keyof this['values'], U extends string>(map: Record<U, T>): Record<U, string>;
	/**
	 * 다중 구문을 얻습니다.
	 * @param tokens
	 */
	gets<T extends keyof this['values']>(tokens: T[]): Record<T, string>;
	gets(tokens){
		return super.gets(tokens as any) as any;
	}

	/**
	 * 모든 구문을 얻습니다.
	 * `$`로 시작하는 동적 구문은 제외 됩니다.
	 */
	getAll(): this['values'] {
		return super.getAll();
	}
}